import { EmptyState, FlexColumn } from '@gorila-shared-ui/components';
import { Accordion, Panel } from 'baseui/accordion';
import { useEffect } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { activeDeliveryState, deliveryReportStates, reportSelectedAssetIdsState } from '../../../storage/reports';
import { DeliveryReportTableFromAsset } from './DeliveryReportTableFromAsset';
import DeliveryReportTitle from './DeliveryReportTitle';

function DeliveryReports() {
  const { css } = useStyles();
  const resetDeliveryReports = useResetRecoilState(deliveryReportStates);
  const selectedAssetIds = useRecoilValue(reportSelectedAssetIdsState);
  const setActiveReport = useSetRecoilState(activeDeliveryState);

  useEffect(() => {
    return () => {
      resetDeliveryReports();
    };
  }, []);

  if (!selectedAssetIds?.length) {
    return <EmptyState title="Selecciona un activo para visualizar el reporte." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      <AutoSizer>
        {({ width, height }) => (
          <div style={{ width, height, overflow: 'auto' }}>
            <Accordion
              key={selectedAssetIds[0]}
              initialState={{ expanded: [selectedAssetIds[0]] }}
              onChange={({ expanded }) => setActiveReport(expanded.length ? (expanded[0] as string) : undefined)}
            >
              {selectedAssetIds.map((assetId) => (
                <Panel
                  key={assetId}
                  title={<DeliveryReportTitle assetId={assetId} />}
                  overrides={{
                    Content: {
                      style: {
                        paddingTop: 0,
                      },
                    },
                  }}
                >
                  <DeliveryReportTableFromAsset assetId={assetId} />
                </Panel>
              ))}
            </Accordion>
          </div>
        )}
      </AutoSizer>
    </FlexColumn>
  );
}

export default DeliveryReports;
